// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".accordion[data-v-e39c1650]{position:relative;overflow:hidden;transition-property:height;transition-timing-function:ease-out;will-change:height}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
